// BottomPart.tsx

import { MantineProvider } from "@mantine/core";

import { ServicesFeaturesWhy } from "./ServicesFeaturesWhy";
import { ServicesEthicalFinancing } from "./ServicesEthicalFinancing";

import { LoanFunction } from "./LoanCalc";

function ServicesBottomPart() {
  return (
    <MantineProvider>
      <ServicesFeaturesWhy />
      <ServicesEthicalFinancing />
      <LoanFunction />
    </MantineProvider>
  );
}

export default ServicesBottomPart;
